module.exports = __webpack_public_path__ + "static/media/jean-grey-lose.404bcce7.png";